// extracted by mini-css-extract-plugin
module.exports = {"acceptPage":"style_acceptPage__2uNa6","acceptContainer":"style_acceptContainer__2nvIj","logo":"style_logo__1sXsr"};